// extracted by css-extract-rspack-plugin
var _1 = "QvWzb0rl8eQjARmm";
var _2 = "_s_dh0FCb4jKeTUd";
var _3 = "HPV8s6zHAFIMLWlh";
var _4 = "oq7zpNhuQgggnPRZ";
var _5 = "xFAtzfmfHL89J4ud";
var _6 = "G0GyDFRVs8YaAmKc";
var _7 = "TFDk957kZUYhoecN";
var _8 = "HCG2q_UKXo_CLPjv";
var _9 = "ZOcvOByJu3IIY_Ef";
var _a = "ENyYDvd4EIUL8pvH";
var _b = "fqqF_kIbbdUxbrX9";
export { _1 as "column", _2 as "contactBox", _3 as "copyright", _4 as "copyrightHolder", _5 as "footer", _6 as "logo", _7 as "panelList", _8 as "panelMarginMid", _9 as "panelsWrap", _a as "socialIcon", _b as "socialIconsHolder" }
// extracted by css-extract-rspack-plugin
var _1 = "QvWzb0rl8eQjARmm";
var _2 = "_s_dh0FCb4jKeTUd";
var _3 = "HPV8s6zHAFIMLWlh";
var _4 = "oq7zpNhuQgggnPRZ";
var _5 = "xFAtzfmfHL89J4ud";
var _6 = "G0GyDFRVs8YaAmKc";
var _7 = "TFDk957kZUYhoecN";
var _8 = "HCG2q_UKXo_CLPjv";
var _9 = "ZOcvOByJu3IIY_Ef";
var _a = "ENyYDvd4EIUL8pvH";
var _b = "fqqF_kIbbdUxbrX9";
export { _1 as "column", _2 as "contactBox", _3 as "copyright", _4 as "copyrightHolder", _5 as "footer", _6 as "logo", _7 as "panelList", _8 as "panelMarginMid", _9 as "panelsWrap", _a as "socialIcon", _b as "socialIconsHolder" }
